// 공정 표준(`0106`) — 판·항목·글은 조직 무관 전역이고 쓰기는 운영자(service_role)만.

import type { BaseRow } from "../common/types";
import type { PhaseCode } from "../template/phases";

export const PROCESS_STANDARD_COUNTRIES = ["KR"] as const;
export type ProcessStandardCountry = (typeof PROCESS_STANDARD_COUNTRIES)[number];

// 회사 보정(#171) 범위 — 화면(클라이언트)도 읽어 repo 를 끌고 오는 calibration 대신 여기 둔다.
export const PROCESS_FACTOR_MIN = 0.5;
export const PROCESS_FACTOR_MAX = 3;
export const PROCESS_CREW_MAX = 50;

// 금액 글 금지(약관 제6조) — 위키 편집·Q&A 질문·답변 화면이 같은 문구를 쓴다.
export const PRICE_INFO_BAN_TEXT = "가격·단가·원가 같은 금액 정보는 올릴 수 없습니다.";
export const PRICE_INFO_QNA_NOTICE = `${PRICE_INFO_BAN_TEXT} 신고되면 운영자가 지웁니다.`;

export const PROCESS_STANDARD_UNITS = ["m2"] as const;
export type ProcessStandardUnit = (typeof PROCESS_STANDARD_UNITS)[number];

// 나라별 판 — 숫자가 바뀌면 새 판 · 견적은 만들 때 판을 고정한다(#384).
export interface ProcessStandardVersion extends BaseRow {
  country: ProcessStandardCountry;
  version: number;
  label: string;
  published_at: string;
  note: string | null;
}

export interface ProcessStandardItem extends BaseRow {
  version_id: string;
  code: string;
  phase_code: PhaseCode;
  name: string;
  unit: ProcessStandardUnit;
  // 기능공 수 — 일수 계산 기준 · 보통인부(laborer_size, `0121`)는 인원에만 더한다(품셈 팀 작업량에 이미 포함).
  crew_size: number;
  laborer_size: number;
  output_per_person_day: number;
  curing_days: number;
  source: string;
  sort_order: number;
}

// 항목 코드마다 시공법 글 — 판 없이 즉시 반영(#384).
export interface ProcessStandardArticle extends BaseRow {
  code: string;
  title: string;
  body: string;
  updated_by_org_name: string | null;
}
